
export const tokenSelector = state => state.login.token;
export const roleSelector = state => state.login.user.role;
export const hasAcademy = state => !(
  state.login.user.academy === null || state.login.user.academy === undefined
);
export const permissionsSelector = state => state.login.user.permissions;
export const canSelector = state => permission => state.login.user.permissions.includes(permission);
